import PropTypes from 'prop-types'

import React from 'react'
import IntlTelInput from 'react-intl-tel-input'

import { isAllowTypeNumberic } from '../../commons/helpers'
import './style.scss'

const InputPhone = (props) => {
  const {
    value,
    name,
    onChange,
    onPhoneNumberBlur,
    onCountryCodeValueChanged,
    defaultCountryValue,
    disabled,
    placeholder,
    wPer100,
    noStyleFocus,
  } = props
  return (
    <div className={`Input-Flag ${wPer100 ? 'width-per-100' : ''}`}>
      <IntlTelInput
        value={value}
        onlyCountries={['vn', 'id', 'th', 'ph']}
        preferredCountries={[]}
        containerClassName="intl-tel-input block-important Select-Container"
        inputClassName={`${!noStyleFocus && 'form-control'}`}
        placeholder={placeholder}
        separateDialCode
        defaultCountry={defaultCountryValue}
        // Has params not use but include to get true params nesscessary from callback.
        onPhoneNumberChange={(noResponse, phoneNumber) => {
          if (isAllowTypeNumberic(phoneNumber)) {
            onChange(phoneNumber)
          }
        }}
        onSelectFlag={(phoneNumber, country) => {
          onCountryCodeValueChanged(country)
        }}
        onPhoneNumberBlur={() => {
          onPhoneNumberBlur()
        }}
        fieldName={name}
        disabled={disabled}
      />
    </div>
  )
}

InputPhone.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onPhoneNumberBlur: PropTypes.func,
  onCountryCodeValueChanged: PropTypes.func.isRequired,
  defaultCountryValue: PropTypes.string.isRequired,
}

InputPhone.defaultProps = {
  value: '',
  name: '',
  onPhoneNumberBlur: () => {},
}
export default InputPhone
